
import { defineComponent } from 'vue'
import { RouteMeta, _RouteRecordBase } from 'vue-router'
import theme from '@/utils/theme'

export default defineComponent({
    name: 'Home',
    mounted () {
        // 初始化主题
        theme.init()
    },
    watch: {
        $route (to: _RouteRecordBase) {
            const name = to.name as string
            const meta = to.meta as RouteMeta
            if (meta.keepAlive && this.includeList.indexOf(name) === -1) {
                this.includeList.push(name)
                console.log(this.includeList)
            }
            console.log(this.includeList)
        }
    },
    data () {
        return {
            isNav: false,
            theme: {
                _text: 'red'
            },
            includeList: [] as string[]
        }
    }
})
